import { render, staticRenderFns } from "./InscritsAtelier.vue?vue&type=template&id=4b3f69e4"
import script from "./InscritsAtelier.vue?vue&type=script&lang=js"
export * from "./InscritsAtelier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports